export default "__VITE_ASSET__f95a3e32__"